
export default {
    props: {
        item: {
            type: Object
        }
    },
    data() {
        return {
            article_image: ""
        }
    },
    methods: {
        randomImage() {
            let tmpImageArray = [
                location.origin + "/img/public/img_default_01.png",
                location.origin + "/img/public/img_default_02.png",
                location.origin + "/img/public/img_default_03.png",
            ];
            tmpImageArray.sort(() => Math.random() - 0.5);
            tmpImageArray = tmpImageArray.slice(0, 1);
            let tmpImage = tmpImageArray[0];
            return tmpImage;
        },
        formatImage() {
            const vm = this;
            let newImg = new Image();
            let tmpReImage = vm.item.image;
            newImg.src = tmpReImage;
            newImg.onerror = () => {
                newImg.src = vm.randomImage();
            };
            newImg.onload = () => {
                vm.article_image = newImg.src;
            };
        }
    },
    mounted() {
        const vm = this;
        vm.formatImage();
    }
}
